export default __webpack_public_path__ + "static/EzyMedical ENG - Homepage Banner (EDP)-ed56d02fd66c5c261eefe638abf73893.png";